import {
	ActivateMaterialItemMutation,
	AdjustMaterialItemMutation,
	AssignMaterialItemToVendorMutation,
	CountMaterialItemMutation,
	CreateMaterialItemMutation,
	CreateOrUpdateTagByTagCodeMutation,
	CreateTagMutation,
	DeleteMaterialItemMutation,
	InactivateMaterialItemMutation,
	MoveMaterialItemMutation,
	SetDefaultVendorMutation,
	SetMaterialItemBatchTrackingMutation,
	SetMaterialItemImageMutation,
	SetMaterialItemTagSpecMutation,
	UnassignMaterialItemToVendorMutation,
	UndeleteMaterialItemMutation,
	UpdateMaterialItemDetailsMutation
} from "~/gql/mutations/material.generated";
import {
	GetCountReasonsQuery,
	GetMaterialItemLocationQuantitiesQuery,
	GetMaterialItemQuery,
	GetMaterialItemSiteLocationQuantitiesQuery,
	GetMaterialItemsQuery,
	GetMaterialTransactionsQuery,
	GetProduceTagsByTagCodesQuery,
	GetProduceTagsQuery,
	GetSellableHardgoodsQuery
} from "~/gql/queries/material.generated";
import { ResolveProduceTagsQuery } from "~/gql/queries/produce/produceTagResolution.generated";

export const materialEndpoints = {
	ActivateMaterialItem: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: ActivateMaterialItemMutation) => {
			return res;
		}
	},
	AdjustMaterialItem: {
		invalidatesTags: ["InventoryItems", "MaterialItemLocationQuantities", "MaterialTransactions"] as AddTagTypes,
		transformResponse: (res: AdjustMaterialItemMutation) => {
			return res;
		}
	},
	AssignMaterialItemToVendor: {
		invalidatesTags: ["MaterialItems", "VendorMaterialCosts"] as AddTagTypes,
		transformResponse: (res: AssignMaterialItemToVendorMutation) => {
			return res;
		}
	},
	CountMaterialItem: {
		invalidatesTags: [
			"InventoryItems",
			"MaterialItems",
			"MaterialItemLocationQuantities",
			"MaterialTransactions"
		] as AddTagTypes,
		transformResponse: (res: CountMaterialItemMutation) => {
			return res;
		}
	},
	CreateMaterialItem: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: CreateMaterialItemMutation) => {
			return res;
		}
	},
	CreateOrUpdateTagByTagCode: {
		invalidatesTags: ["MaterialItems", "ProduceTags"] as AddTagTypes,
		transformResponse: (res: CreateOrUpdateTagByTagCodeMutation) => {
			return res;
		}
	},
	CreateTag: {
		invalidatesTags: ["MaterialItems", "ProduceTags"] as AddTagTypes,
		transformResponse: (res: CreateTagMutation) => {
			return res;
		}
	},
	DeleteMaterialItem: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: DeleteMaterialItemMutation) => {
			return res;
		}
	},
	GetCountReasons: {
		providesTags: ["CountReasons"] as AddTagTypes,
		transformResponse: (res: GetCountReasonsQuery) => {
			return res;
		}
	},
	GetMaterialItem: {
		providesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: GetMaterialItemQuery) => {
			return res;
		}
	},
	GetMaterialItemLocationQuantities: {
		providesTags: ["MaterialItemLocationQuantities"] as AddTagTypes,
		transformResponse: (res: GetMaterialItemLocationQuantitiesQuery) => {
			return res;
		}
	},
	GetMaterialItems: {
		providesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: GetMaterialItemsQuery) => {
			return res;
		}
	},
	GetMaterialItemSiteLocationQuantities: {
		providesTags: ["MaterialItemLocationQuantities"] as AddTagTypes,
		transformResponse: (res: GetMaterialItemSiteLocationQuantitiesQuery) => {
			return res;
		}
	},
	GetMaterialTransactions: {
		providesTags: ["MaterialTransactions"] as AddTagTypes,
		transformResponse: (res: GetMaterialTransactionsQuery) => res
	},
	GetProduceTags: {
		providesTags: ["ProduceTags"] as AddTagTypes,
		transformResponse: (res: GetProduceTagsQuery) => {
			return res;
		}
	},
	GetProduceTagsByTagCodes: {
		providesTags: ["ProduceTags"] as AddTagTypes,
		transformResponse: (res: GetProduceTagsByTagCodesQuery) => res
	},
	GetSellableHardgoods: {
		providesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: GetSellableHardgoodsQuery) => {
			return res;
		}
	},
	InactivateMaterialItem: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: InactivateMaterialItemMutation) => {
			return res;
		}
	},
	MoveMaterialItem: {
		invalidatesTags: ["MaterialItemLocationQuantities", "MaterialTransactions"] as AddTagTypes,
		transformResponse: (res: MoveMaterialItemMutation) => {
			return res;
		}
	},
	ResolveProduceTags: {
		providesTags: ["ProduceTags"] as AddTagTypes,
		transformResponse: (res: ResolveProduceTagsQuery) => res
	},
	SetDefaultVendor: {
		invalidatesTags: ["MaterialItems", "VendorMaterialCosts"] as AddTagTypes,
		transformResponse: (res: SetDefaultVendorMutation) => {
			return res;
		}
	},
	SetMaterialItemBatchTracking: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: SetMaterialItemBatchTrackingMutation) => {
			return res;
		}
	},
	SetMaterialItemImage: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: SetMaterialItemImageMutation) => res
	},
	SetMaterialItemTagSpec: {
		invalidatesTags: ["MaterialItems", "ProduceTags"] as AddTagTypes,
		transformResponse: (res: SetMaterialItemTagSpecMutation) => {
			return res;
		}
	},
	UnassignMaterialItemToVendor: {
		invalidatesTags: ["MaterialItems", "VendorMaterialCosts"] as AddTagTypes,
		transformResponse: (res: UnassignMaterialItemToVendorMutation) => {
			return res;
		}
	},
	UndeleteMaterialItem: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: UndeleteMaterialItemMutation) => {
			return res;
		}
	},
	UpdateMaterialItemDetails: {
		invalidatesTags: ["MaterialItems"] as AddTagTypes,
		transformResponse: (res: UpdateMaterialItemDetailsMutation) => {
			return res;
		}
	}
};
